import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  search: {
    marginBottom: pxToRem(32),
  },
  iconColumn: {
    height: pxToRem(20),
    width: pxToRem(20),
    textAlign: 'center',
    fontSize: '1rem',
    paddingTop: pxToRem(3),
  },
  detailRowIconColor: {
    color: theme.palette.neutralTertiary,
  },
  productText: {
    width: pxToRem(320),
    fontSize: pxToRem(12),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    paddingRight: pxToRem(20),
  },
  moreProductIds: {
    color: theme.palette.themePrimary,
    cursor: 'pointer',
  },
  tooltipContent: {
    margin: pxToRem(5),
    padding: pxToRem(15),
  },
  exportToExcel: {
    marginBottom: pxToRem(32),
  },
  bulletedList: {
    paddingRight: pxToRem(10),
  },
  searchContainer: {
    justifyContent: 'space-between',
    display: 'flex',
    alignItems: 'center',
  },
  tokenHeader: {
    paddingTop: pxToRem(4),
    selectors: {
      '& .ms-TooltipHost': {
        paddingBottom: pxToRem(2),
      },
    },
  },
  scrollablePane: {
    width: 'fit-content',
    '& [role=grid]': {
      maxHeight: pxToRem(450),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
    },
    '& .ms-DetailsList-headerWrapper': {
      flex: '0 0 auto',
    },
    '& .ms-DetailsList-contentWrapper': {
      flex: '1 1 auto',
      overflowY: 'auto',
      overflowX: 'hidden',
    },
  },
  viewButton: {
    marginLeft: pxToRem(40),
    fontSize: pxToRem(14),
  },
  infoIcon: {
    paddingBottom: pxToRem(3),
  },
  productsCount: {
    paddingTop: pxToRem(5),
  },
});
